import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import NFTMarketplace from "views/admin/marketplace";
import Profile from "views/admin/profile";
import EmailTemplate from "views/admin/emailTemplate";
import DataTables from "views/admin/tables";
import { RiCoupon3Line } from "react-icons/ri";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdHome,
  MdOutlineShoppingCart,
  MdBarChart,
  MdPerson,
  MdLock,
  MdOutlineStorefront,
  MdOutlineLocalLaundryService,
  MdOutlinePayments,
  MdReportGmailerrorred,
  MdAdUnits,
  MdDriveEta,
  MdOutlineNextPlan,
  MdOutlineMapsUgc,
  MdDensitySmall,
  MdOutlineInsertChartOutlined,
  MdOutlineReviews,
  MdOutlineLocalOffer,
  MdSupport,
  MdSupportAgent,
  MdOutlineEditNotifications,
  MdContacts,
  MdOutlinePrivacyTip,
  MdEditNote,
} from "react-icons/md";
import { FaQuestion, FaUserMd } from "react-icons/fa";
import { PiChatsDuotone, PiNotepad } from "react-icons/pi";
import { GoInbox } from "react-icons/go";
import { TbSettingsDown, TbTruckDelivery, TbUsersGroup } from "react-icons/tb";
import { CgProfile } from "react-icons/cg";
import { TfiEmail } from "react-icons/tfi";
import { LuLayoutDashboard } from "react-icons/lu";
import { IoCarSportOutline } from "react-icons/io5";
import { PiUserCircleGearThin } from "react-icons/pi";
import { IoNotificationsOutline } from "react-icons/io5";

import Dashboard from "views/admin/dashboared";
// import Order from "views/admin/orders";
import ForgotPassword from "views/auth/forgetPassword";
import VerifyOTP from "views/auth/otpVerfication";
import ResetPassword from "views/auth/resetPassword";
import StoreManagement from "views/admin/storeManagement";
import LaundrymanManagement from "views/admin/laundrymanManagement";
import PaymentManagement from "views/admin/paymentManagement";
import OrderManagement from "views/admin/orderManagement";
import ConditionManagement from "views/admin/conditionManagement";
import ReportGeneration from "views/admin/reportGeneration";
import CustomerManagement from "views/admin/customerManagement";
import CreateCustomer from "views/admin/customerManagement/CreateCustomer";
// import ListCustomer from "views/admin/customerManagement/ListCustomer";
import { Outlet } from "react-router-dom";
// import ListCustomer from "views/admin/customerManagement/listCustomer";
import CreateStore from "views/admin/storeManagement/CreateStore";
import ListStore from "views/admin/storeManagement/listStore";
import ListCustomer from "views/admin/customerManagement/listCustomer";
import OrderDetail from "views/admin/orderManagement/orderDetail.js/orderDetail";
import CreateLaundryMan from "views/admin/laundrymanManagement/CreateLaundryMan";
import ListLaundryMan from "views/admin/laundrymanManagement/ListLaundryMan";
import CreateUser from "views/admin/Users/CreateUser";
import ListUser from "views/admin/Users/listUser";
import Users from "views/admin/Users";
import MainlaundryManagement from "views/admin/mainlaundryManagement";
import CreateLaundry from "views/admin/mainlaundryManagement/CreateLaundry";
import ListLaundry from "views/admin/mainlaundryManagement/ListLaundry";
import CreateRole from "views/admin/roleManagement/CreateRole";
import ListRole from "views/admin/roleManagement/ListRole";
import RoleManagement from "views/admin/roleManagement";
import Catagorymanagemnt from "views/admin/catagorymanagemnt";
import CreateCatagory from "views/admin/catagorymanagemnt/CreateCatagory";
import ListCatagory from "views/admin/catagorymanagemnt/ListCatagory";
import ServicesManagemnt from "views/admin/ServicesManagemnt";
import CreateService from "views/admin/ServicesManagemnt/CreateService";
import ListService from "views/admin/ServicesManagemnt/ListService";
import CouponManagement from "views/admin/couponmanagement";
import CreateCoupon from "views/admin/couponmanagement/CreateCoupon";
import ServicesItemManagemnt from "views/admin/itemServicesManagement";
import CreateItemService from "views/admin/itemServicesManagement/CreateItemService";
import ListItemService from "views/admin/itemServicesManagement/ListItemService";
import ItemManagemnt from "views/admin/itemManagement";
import ListItem from "views/admin/itemManagement/ListItem";
import CreateItem from "views/admin/itemManagement/CreateItem";
import PlansManagement from "views/admin/planesManagement";
import CreatePlan from "views/admin/planesManagement/CreatePlan";
import ListPlan from "views/admin/planesManagement/ListPlan";
import ListCoupon from "views/admin/couponmanagement/ListCoupon";
import paymenIcon from "./assets/img/icons/payment.png";
import storeIcon from "./assets/img/icons/store-5072304-4246334.webp";
import laundryIcon from "./assets/img/icons/8104175.webp";
import CreatePayment from "views/admin/paymentManagement/CreatePayment";
import ListPayment from "views/admin/paymentManagement/ListPayment";
import CreateOrder from "views/admin/orderManagement/CreateOrder";
import ListOrder from "views/admin/orderManagement/ListOrder";
import LaundryBoxManagement from "views/admin/laundryBoxmanagement";
import CreateLaundryBox from "views/admin/laundryBoxmanagement/CreateLaundryBox";
import ListlaundryBox from "views/admin/laundryBoxmanagement/listlaundryBox";
import AreaManagement from "views/admin/areamanagement";
import CreateArea from "views/admin/areamanagement/CreateArea";
import ListArea from "views/admin/areamanagement/ListArea";
import Notification from "views/admin/notificationmanagement/Notification";
import DeliveryChargesManager from "views/admin/deleverycharges/DeliveryChargesManager";
import Settings from "views/admin/settings/Settings";
import NotificationManage from "views/admin/settings/NotificationManage";
import ContactUs from "views/admin/settings/ContactUs";
import AboutUs from "views/admin/settings/AboutUs";
import PrivacyPolicy from "views/admin/settings/PrivacyPolicy";
import TermsOfServices from "views/admin/settings/TermsOfServices";
import DeliveryCost from "views/admin/settings/DeliveryCost";
import Chat from "views/admin/chatSystem/Chat";
import Reviews from "views/admin/Reviews";
import { TiChartAreaOutline } from "react-icons/ti";
import OfferManagement from "views/admin/offersmanagement";
import CreateOffer from "views/admin/offersmanagement/CreateOffer";
import ListOffer from "views/admin/offersmanagement/ListOffer";
import DeleveryCharges from "views/admin/deleverycharges";
import CreateDeleveryCharge from "views/admin/deleverycharges/CreateDeleveryCharge";
import ListDeleveryCharge from "views/admin/deleverycharges/ListDeleveryCharge";
import AddOrder from "views/admin/orderManagement/CreateOrder/CreateOrderUpdated";
import Wallet from "views/admin/Walletmanagement/Wallet";
import ViewLaundryBoxOrder from "views/admin/orderManagement/ViewLaundryBox/ViewLaundryBoxOrder";
import AllLaundryBoxes from "components/Tables/Orders/AllLaundryBoxes";
import CreateEmailTemplate from "views/admin/emailTemplate/CreateEmailTemplate";
import ListEmailTemplate from "views/admin/emailTemplate/ListEmailTemplate";
import UpdateEmailTemplate from "views/admin/emailTemplate/UpdateEmailTemplate";
import CustomerSupport from "views/admin/customerSupport";
import CustomerSupportTable from "components/Tables/CustomerSupportTable/CustomerSupportTable";
// import TaxManagement from "views/admin/taxManagement";
import CreateTax from "views/admin/taxManagement/CreateTax";
import ListTax from "views/admin/taxManagement/ListTax";
import TaxManagement from "views/admin/taxManagement";
import FaqManagement from "views/admin/Faqs";
import ListFAQ from "views/admin/Faqs/ListFaq";
import CreateFaq from "views/admin/Faqs/CreateFaq";
// import ViewLaundryBox from "views/admin/laundryBoxmanagement/ViewLaundryBox/ViewLaundryBox";

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "dashboared",
    icon: <LuLayoutDashboard className="h-6 w-6" />,
    component: <MainDashboard />,
    // component: <Dashboard />,
  },
  
  {
    name: "Order",
    layout: "/admin",
    path: "order-management",
    icon: <PiNotepad className="h-6 w-6" />,
    component: (
      <OrderManagement>
        <Outlet />
      </OrderManagement>
    ),
    secondary: true,
    children: [
      {
        name: "Create Order",
        layout: "/admin",
        path: "create-order",
        // component: <CreateOrder />,
        component: <AddOrder />,
      },
      {
        name: "Listing Order",
        layout: "/admin",
        path: "order-tables",
        component: <ListOrder />,
      },
      {
        name: "laundrybox",
        layout: "/admin",
        path: "view-laundrybox-order",
        component: <AllLaundryBoxes />,
      },
    ],
  },
  {
    name: "Customer Support",
    layout: "/admin",
    path: "customer-support",
    icon: <MdSupportAgent className="h-6 w-6" />,
    component: (
      <CustomerSupport>
        <Outlet />
      </CustomerSupport>
    ),
    secondary: true,
    children: [
      {
        name: "Create Area",
        layout: "/admin",
        path: "create-area",
        component: <CreateArea />,
      },
      {
        name: "Listing Customer",
        layout: "/admin",
        path: "customer-tables",
        component: <CustomerSupportTable />,
      },
    ],
  },
  {
    name: "Laundry Box",
    layout: "/admin",
    path: "laundry-box",
    icon: <GoInbox className="h-6 w-6" />,
    component: (
      <LaundryBoxManagement>
        <Outlet />
      </LaundryBoxManagement>
    ),
    secondary: true,
    children: [
      {
        name: "Create laundry-box",
        layout: "/admin",
        path: "create-laundry-box",
        component: <CreateLaundryBox />,
      },
      {
        name: "Listing laundry-box",
        layout: "/admin",
        path: "laundry-box-tables",
        component: <ListlaundryBox />,
      },
    ],
  },

  {
    name: "Driver",
    layout: "/admin",
    path: "laundryman-management",

    icon: <IoCarSportOutline className="h-6 w-6" />,
    component: (
      <LaundrymanManagement>
        <Outlet />
      </LaundrymanManagement>
    ),
    secondary: true,
    children: [
      {
        name: "Create Driver",
        layout: "/admin",
        path: "create-store",
        component: <CreateLaundryMan />,
      },
      {
        name: "Listing Driver",
        layout: "/admin",
        path: "laundryman-tables",
        component: <ListLaundryMan />,
      },
    ],
  },
  {
    name: "Store",
    layout: "/admin",
    path: "store-management",
    icon: <MdOutlineStorefront className="h-6 w-6" />,
    // icon: <img src={storeIcon} className="h-10 w-10" />,
    component: (
      <StoreManagement>
        <Outlet />
      </StoreManagement>
    ),
    secondary: true,
    children: [
      {
        name: "Create Store",
        layout: "/admin",
        path: "create-store",
        component: <CreateStore />,
      },
      {
        name: "Listing Store",
        layout: "/admin",
        path: "store-tables",
        component: <ListStore />,
      },
    ],
  },
  {
    name: "Main Laundry",
    layout: "/admin",
    path: "main-laundry-management",
    icon: <MdOutlineStorefront className="h-6 w-6" />,
    // icon: <img src={storeIcon} className="h-10 w-10" />,
    component: (
      <MainlaundryManagement>
        <Outlet />
      </MainlaundryManagement>
    ),
    secondary: true,
    children: [
      {
        name: "Create Laundry",
        layout: "/admin",
        path: "create-laundry",
        component: <CreateLaundry />,
      },
      {
        name: "Listing Laundry",
        layout: "/admin",
        path: "laundry-tables",
        component: <ListLaundry />,
      },
    ],
  },
  {
    name: "users",
    layout: "/admin",
    path: "lusers",

    icon: <TbUsersGroup className="h-6 w-6" />,
    component: (
      <Users>
        <Outlet />
      </Users>
    ),
    secondary: true,
    children: [
      {
        name: "Create User",
        layout: "/admin",
        path: "create-user",
        component: <CreateUser />,
      },
      {
        name: "Listing User",
        layout: "/admin",
        path: "user-tables",
        component: <ListUser />,
      },
    ],
  },
  {
    name: "Wallet",
    layout: "/admin",
    path: "wallet",
    icon: <LuLayoutDashboard className="h-6 w-6" />,
    component: <Wallet />,
    // component: <Dashboard />,
  },
  {
    name: "Report Generation",
    layout: "/admin",
    // path: "nft-marketplace",
    path: "report-generation",
    icon: <MdReportGmailerrorred className="h-6 w-6" />,
    // component: <NFTMarketplace />,
    component: <ReportGeneration />,
    secondary: true,
  },
  {
    name: "Coupon",
    layout: "/admin",
    path: "main-coupon-management",
    icon: <RiCoupon3Line className="h-6 w-6" />,
    component: (
      <CouponManagement>
        <Outlet />
      </CouponManagement>
    ),
    secondary: true,
    children: [
      {
        name: "Create Coupon",
        layout: "/admin",
        path: "create-Coupon",
        component: <CreateCoupon />,
      },
      {
        name: "Listing Coupon",
        layout: "/admin",
        path: "coupon-tables",
        component: <ListCoupon />,
      },
    ],
  },
  {
    name: "Offer",
    layout: "/admin",
    path: "offer-management",
    icon: <MdOutlineLocalOffer className="h-6 w-6" />,
    component: (
      <OfferManagement>
        <Outlet />
      </OfferManagement>
    ),
    secondary: true,
    children: [
      {
        name: "Create Offer",
        layout: "/admin",
        path: "create-offer",
        component: <CreateOffer />,
      },
      {
        name: "Listing Offer",
        layout: "/admin",
        path: "offer-tables",
        component: <ListOffer />,
      },
    ],
  },
  {
    name: "Items",
    layout: "/admin",
    path: "items",
    icon: <MdDensitySmall className="h-6 w-6" />,
    component: (
      <ItemManagemnt>
        <Outlet />
      </ItemManagemnt>
    ),
    secondary: true,
    children: [
      {
        name: "Create Item",
        layout: "/admin",
        path: "create-item",
        component: <CreateItem />,
      },
      {
        name: "Listing Item",
        layout: "/admin",
        path: "item-tables",
        component: <ListItem />,
      },
    ],
  },
  {
    name: "Catagory",
    layout: "/admin",
    path: "catagory",

    icon: <MdOutlineMapsUgc className="h-6 w-6" />,
    component: (
      <Catagorymanagemnt>
        <Outlet />
      </Catagorymanagemnt>
    ),
    secondary: true,
    children: [
      {
        name: "Create Catagory",
        layout: "/admin",
        path: "create-catagory",
        component: <CreateCatagory />,
      },
      {
        name: "Listing Catagory",
        layout: "/admin",
        path: "catagory-tables",
        component: <ListCatagory />,
      },
    ],
  },
  {
    name: "Item Services",
    layout: "/admin",
    path: "item-services",
    icon: <MdOutlineInsertChartOutlined className="h-6 w-6" />,
    secondary: true,
    component: (
      <ServicesItemManagemnt>
        <Outlet />
      </ServicesItemManagemnt>
    ),
    children: [
      {
        name: "Create Item-Service",
        layout: "/admin",
        path: "create-item-Service",
        component: <CreateItemService />,
      },
      {
        name: "Listing Item-Service",
        layout: "/admin",
        path: "item-service-tables",
        component: <ListItemService />,
      },
    ],
  },
  {
    name: "Contact Us",
    layout: "/admin",
    path: "contact-us",
    component: <ContactUs />,
    icon: <MdContacts className="h-6 w-6" />,
  },
  {
    name: "Notification",
    layout: "/admin",
    path: "notification",
    icon: <IoNotificationsOutline className="h-6 w-6" />,
    component: <Notification />,
    // component: <Dashboard />,
  },
  {
    name: "Membership Plan",
    layout: "/admin",
    path: "plan-management",
    icon: <MdOutlineNextPlan className="h-6 w-6" />,
    component: (
      <PlansManagement>
        <Outlet />
      </PlansManagement>
    ),
    secondary: true,
    children: [
      {
        name: "Create plan",
        layout: "/admin",
        path: "create-plan",
        component: <CreatePlan />,
      },
      {
        name: "Listing plan",
        layout: "/admin",
        path: "plan-tables",
        component: <ListPlan />,
      },
    ],
  },
  {
    name: "Delivery Charges",
    layout: "/admin",
    path: "deliverycharges",
    icon: <TbTruckDelivery className="h-6 w-6" />,
    secondary: true,
    component: (
      <DeleveryCharges>
        <Outlet />
      </DeleveryCharges>
    ),
    children: [
      {
        name: "Create Delevery Charge",
        layout: "/admin",
        path: "create-delevery-charge",
        component: <CreateDeleveryCharge />,
      },
      {
        name: "Delevery Charge",
        layout: "/admin",
        path: "delevery-charge",
        component: <ListDeleveryCharge />,
      },
    ],
  },
  {
    name: "Tax",
    layout: "/admin",
    path: "tax",
    icon: <TbUsersGroup className="h-6 w-6" />,
    component: (
      <TaxManagement>
        <Outlet />
      </TaxManagement>
    ),
    secondary: true,
    children: [
      {
        name: "Create tax",
        layout: "/admin",
        path: "create-tax",
        component: <CreateTax />,
      },
      {
        name: "Listing tax",
        layout: "/admin",
        path: "tax-tables",
        component: <ListTax />,
      },
    ],
  },
  {
    name: "Reviews",
    layout: "/admin",
    path: "reviews",
    icon: <MdOutlineReviews className="h-6 w-6" />,
    component: <Reviews />,
    // component: <Dashboard />,
  },
  {
    name: "Email",
    layout: "/admin",
    path: "email",
    icon: <TfiEmail className="h-6 w-6" />,
    component: (
      <EmailTemplate>
        <Outlet />
      </EmailTemplate>
    ),
    secondary: true,
    children: [
      {
        name: "Create Template",
        layout: "/admin",
        path: "create-email-template",
        component: <CreateEmailTemplate />,
      },
      {
        name: "List Email Template",
        layout: "/admin",
        path: "list-email-template",
        component: <ListEmailTemplate />,
      },
      {
        name: "Update Email Template",
        layout: "/admin",
        path: "update-email-template/:id",
        component: <UpdateEmailTemplate />,
      },
    ],
  },
  {
    name: "About us",
    layout: "/admin",
    path: "about-us",
    component: <AboutUs />,
    icon: <MdOutlineEditNotifications className="h-6 w-6" />,
  },
  {
    name: "Privacy Policy",
    layout: "/admin",
    path: "privacy-policy",
    component: <PrivacyPolicy />,
    icon: <MdOutlinePrivacyTip className="h-6 w-6" />,
  },
  {
    name: "Terms of services",
    layout: "/admin",
    path: "terms-of-services",
    component: <TermsOfServices />,
    icon: <MdEditNote className="h-6 w-6" />,
  },
  // {
  //   name: "Settings",
  //   layout: "/admin",
  //   path: "settings",
  //   icon: <TbSettingsDown className="h-6 w-6" />,
  //   secondary: true,

  //   component: (
  //     <Settings>
  //       <Outlet />
  //     </Settings>
  //   ),
  //   secondary: true,
  //   children: [
  //     // {
  //     //   name: "Notification Manage",
  //     //   layout: "/admin",
  //     //   path: "notify-manage",
  //     //   component: <NotificationManage />,
  //     //   icon: <MdOutlineEditNotifications className="h-6 w-6" />,
  //     // },
  //     // {
  //     //   name: "Contact Us",
  //     //   layout: "/admin",
  //     //   path: "contact-us",
  //     //   component: <ContactUs />,
  //     //   icon: <MdContacts className="h-6 w-6" />,
  //     // },
  //     // {
  //     //   name: "About us",
  //     //   layout: "/admin",
  //     //   path: "about-us",
  //     //   component: <AboutUs />,
  //     //   icon: <MdOutlineEditNotifications className="h-6 w-6" />,
  //     // },
  //     // {
  //     //   name: "Privacy Policy",
  //     //   layout: "/admin",
  //     //   path: "privacy-policy",
  //     //   component: <PrivacyPolicy />,
  //     //   icon: <MdOutlinePrivacyTip className="h-6 w-6" />,
  //     // },
  //     // {
  //     //   name: "Terms of services",
  //     //   layout: "/admin",
  //     //   path: "terms-of-services",
  //     //   component: <TermsOfServices />,
  //     //   icon: <MdEditNote className="h-6 w-6" />,
  //     // },

  //     // {
  //     //   name: "Delivery cost",
  //     //   layout: "/admin",
  //     //   path: "delivery-cost",
  //     //   component: <DeliveryCost />,
  //     // },
  //   ],
  // },
  // {
  //   name: "Payment",
  //   layout: "/admin",
  //   path: "payment-management",
  //   icon: <MdOutlinePayments className="h-6 w-6" />,

  //   // icon: <img src={paymenIcon} className="h-6 w-6" />,
  //   component: <PaymentManagement />,
  //   secondary: true,
  // },


  // {
  //   name: "Order",
  //   layout: "/admin",
  //   path: "order-management",
  //   icon: <MdOutlineShoppingCart className="h-6 w-6" />,

  //   component: <OrderDetail />,
  //   secondary: true,
  // },

  // {
  //   name: "Condition",
  //   layout: "/admin",
  //   path: "condition-management",
  //   icon: <MdAdUnits className="h-6 w-6" />,
  //   component: <ConditionManagement />,
  //   secondary: true,
  // },


  // {
  //   name: "Customer Management",
  //   layout: "/admin",
  //   path: "customer-management",
  //   icon: <MdOutlineShoppingCart className="h-6 w-6" />,
  //   component: (
  //     <CustomerManagement>
  //       <Outlet />
  //     </CustomerManagement>
  //   ),
  //   secondary: true,
  //   children: [
  //     {
  //       name: "Create Customer",
  //       layout: "/admin",
  //       path: "create-customer",
  //       // icon: <IconHere />,
  //       component: <CreateCustomer />,
  //     },
  //     {
  //       name: "Listing Customer",
  //       layout: "/admin",
  //       path: "customer-tables",
  //       // icon: <IconHere />,
  //       component: <ListCustomer />,
  //     },
  //   ],
  // },

  // {
  //   // name: "Data Tables",
  //   name: "users",
  //   layout: "/admin",
  //   icon: <MdBarChart className="h-6 w-6" />,
  //   // path: "data-tables",
  //   path: "users",
  //   // component: <DataTables />,
  //   component: <Users />,
  // },

  // {
  //   name: "Role",
  //   layout: "/admin",
  //   path: "role",

  //   icon: <PiUserCircleGearThin className="h-6 w-6" />,
  //   component: (
  //     <RoleManagement>
  //       <Outlet />
  //     </RoleManagement>
  //   ),
  //   secondary: true,
  //   children: [
  //     {
  //       name: "Create Role",
  //       layout: "/admin",
  //       path: "create-role",
  //       component: <CreateRole />,
  //     },
  //     {
  //       name: "Listing Role",
  //       layout: "/admin",
  //       path: "role-tables",
  //       component: <ListRole />,
  //     },
  //   ],
  // },
 
  // {
  //   name: "Services Management",
  //   layout: "/admin",
  //   path: "services",

  //   icon: <MdBarChart className="h-6 w-6" />,
  //   component: (
  //     <ServicesManagemnt>
  //       <Outlet />
  //     </ServicesManagemnt>
  //   ),
  //   secondary: true,
  //   children: [
  //     {
  //       name: "Create Service",
  //       layout: "/admin",
  //       path: "create-Service",
  //       component: <CreateService />,
  //     },
  //     {
  //       name: "Listing Service",
  //       layout: "/admin",
  //       path: "service-tables",
  //       component: <ListService />,
  //     },
  //   ],
  // },

 



 

  // {
  //   name: "Delivery Charges",
  //   layout: "/admin",
  //   path: "deliverycharges",
  //   icon: <TbTruckDelivery className="h-6 w-6" />,
  //   component: <DeleveryCharges />,

  //   // component: <DeliveryChargesManager />,
  //   // component: <Dashboard />,
  // },
  

  {
    name: "FAQ",
    layout: "/admin",
    path: "faq",

    icon: <FaQuestion className="h-6 w-6" />,
    component: (
      <FaqManagement>
        <Outlet />
      </FaqManagement>
    ),
    secondary: true,
    children: [
      {
        name: "Create fFq",
        layout: "/admin",
        path: "create-faq",
        component: <CreateFaq />,
      },
      {
        name: "Listing Faq",
        layout: "/admin",
        path: "faq-tables",
        component: <ListFAQ />,
      },
    ],
  },
  


  {
    name: "Chat",
    layout: "/admin",
    path: "chat",
    icon: <PiChatsDuotone className="h-6 w-6" />,
    component: <Chat />,
  },

  {
    name: "Area",
    layout: "/admin",
    path: "area",
    icon: <TiChartAreaOutline className="h-6 w-6" />,
    component: (
      <AreaManagement>
        <Outlet />
      </AreaManagement>
    ),
    secondary: true,
    children: [
      {
        name: "Create Area",
        layout: "/admin",
        path: "create-area",
        component: <CreateArea />,
      },
      {
        name: "Listing Area",
        layout: "/admin",
        path: "area-tables",
        component: <ListArea />,
      },
    ],
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    icon: <CgProfile className="h-6 w-6" />,
    component: <Profile />,
  },
 
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
  {
    name: "Forget-Password",
    layout: "/auth",
    path: "forgetpass",
    icon: <MdLock className="h-6 w-6" />,
    component: <ForgotPassword />,
  },

  {
    name: "Verify-Otp",
    layout: "/auth",
    path: "verify",
    icon: <MdLock className="h-6 w-6" />,
    component: <VerifyOTP />,
  },
  {
    name: "Reset-Password",
    layout: "/auth",
    path: "reset",
    icon: <MdLock className="h-6 w-6" />,
    component: <ResetPassword />,
  },


  // {
  //   name: "RTL Dashboard",
  //   layout: "/rtl",
  //   path: "rtl",
  //   icon: <MdHome className="h-6 w-6" />,
  //   // component: <RTLDefault />,
  //   component: <Dashboard />,
  // },sing-
];
const adminRoutes = [
  "Dashboard",
  "Main Laundry",
  "Store",
  "Driver",
  "Laundry Box",
  "Coupon",
  "Offer",
  "Membership Plan",
  "Order",
  "Report Generation",
  "Role",
  "Catagory",
  "Items",
  "Item Services",
  "Notification",
  "Delivery Charges",
  // "Settings",
  "FAQ",
  "users",
  "Profile",
  "Email",
  "Reviews",
  "Area",
  "Wallet",
  "Sign In",
  "Forget-Password",
  "Verify-Otp",
  "Reset-Password",
  "Customer Support",
  // "Chat",
  // new chat 

  
  "Tax",
];
const laundryRoutes = [
  "Dashboard",
  "Store",
  "Driver",
  "Laundry Box",
  "Coupon",
  "Offer",
  "Membership Plan",
  "Order",
  "Report Generation",
  "Role",
  "Catagory",
  "Items",
  "Item Services",
  "Notification",
  "Delivery Charges",
  "Tax",
  // "Settings",
  // "Contact Us",
  // "About us",
  "Privacy Policy",
  "Terms of services",

  "FAQ",
  //  "Chat",

  "users",
  "Profile",
  "Email",
  "Reviews",
  // "Area",
  "Wallet",
  "Sign In",
  "Forget-Password",
  "Verify-Otp",
  "Reset-Password",
  "Customer Support",
];
const providerRoutes = [
  "Dashboard",
  "Driver",
  "Order",
  "Catagory",
  "Items",
  "Laundry Box",

  "Report Generation",
  // "Settings",
  "Reviews",
  // "FAQ",
  // "Chat",
  // "About us",
  // "Terms of services",

  "users",
  "Profile",
  "Wallet",
  "Sign In",
  "Forget-Password",
  "Verify-Otp",
  "Reset-Password",
];

const getRoutes = (routeName) => {
  if (routeName === "provider") {
    return providerRoutes || [];
  } else if (routeName === "admin") {
    return adminRoutes || [];
  } else {
    return laundryRoutes || [];
  }
};
const appName = process.env.REACT_APP_APPLICATION_NAME;
const allRoutes = getRoutes(appName);
// Filter the routes and include children for 'Settings'
const filteredRoutes = routes?.reduce((acc, route) => {
  if (allRoutes?.includes(route?.name)) {
    // If the route is 'Settings', include its children
    if (route.name === "Settings" && route.children) {
      return [...acc, route, ...route.children];
    }
    return [...acc, route];
  }
  return acc;
}, []);

// const filteredRoutes = routes?.filter(route => allRoutes?.includes(route?.name));

console.log("routes of all ===>", filteredRoutes);

console.log(filteredRoutes, "filteredRoutes");

export default filteredRoutes;
